
      import API from "!../../../../cf-fe-build-20260905/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../cf-fe-build-20260905/node_modules/style-loader/dist/runtime/singletonStyleDomAPI.js";
      import insertFn from "!../../../../cf-fe-build-20260905/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../cf-fe-build-20260905/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../cf-fe-build-20260905/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      
      import content, * as namedExport from "!!../../../../cf-fe-build-20260905/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../cf-fe-build-20260905/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../cf-fe-build-20260905/node_modules/source-map-loader/dist/cjs.js!./layout.module.css";
      
      

var options = {};

;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../cf-fe-build-20260905/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../cf-fe-build-20260905/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../cf-fe-build-20260905/node_modules/source-map-loader/dist/cjs.js!./layout.module.css";
       export default content && content.locals ? content.locals : undefined;
